/*
  Iconos a aplicar a las secciones del faq. Es un objeto del tipo:
    section-id: icon-name
*/

export default {}
